import { createSelector } from 'reselect';

const authCompany = (companies, auth) => {
  if (!auth?.company_id) {
    return undefined;
  }
  const fromReducer = companies[auth.company_id];
  if (fromReducer) {
    return fromReducer;
  }
  return auth.employee?.user?.companies?.find(c => String(c._id) === String(auth.company_id));
};

export default createSelector(
  state => state.companies,
  state => state.auth,
  authCompany,
);
